export const SELLER_BASE = '/seller';
export const SELLER_V1_BASE = '/v1/seller';
export const CASHIER_V1_BASE = '/v1/cashier';
export const CASHIER_POS_BASE = `${CASHIER_V1_BASE}/pos`;